module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video6.c8286bab.mp4";